module.exports = __webpack_public_path__ + "img/predict-correlations.c777f0c6.png";